import React from 'react'
import ImageGallery from 'react-image-gallery'
import { LYSContainer } from '@core/components/Primitives'
import { useTranslation } from '@core/i18n/i18n'
import { useProductDetailContext } from '@core/utils/models/product/ProductContext'
import { RenderProp, Slot, template } from '@core/utils/templates'
import { useFormattedImages, useImageSelection } from './ProductImageHelper'
import styles from './index.module.less'
import 'react-image-gallery/styles/css/image-gallery.css'
import config from '@core/config/config'
import { usePageContext } from '@core/utils/pages/PageContext'
import FullsizeImageGallery from '@core/components/FullsizeImageGallery'

export interface ProductImageProps {
  className: string
  imagesToShow?: number
}
export interface ProductImageSlots {
  selectedImage: RenderProp<{
    src: string
    className: string
    alt: string
    title: string
  }>
  imageHint: RenderProp<void>
}

const ProductImage = template<ProductImageProps, ProductImageSlots>(
  ({ className, imagesToShow = 3, slots }) => {
    const { variant } = useProductDetailContext() || {}
    const imageSelection = useImageSelection(variant)
    const formattedImages = useFormattedImages()
    const {
      props: { isMobile, isTablet },
    } = usePageContext()

    const isDesktop = !isMobile && !isTablet

    const { t } = useTranslation()
    if (!variant || !imageSelection.images) return null
    const showCarouselArrows = imageSelection.images.length > imagesToShow
    return (
      <LYSContainer className={className}>
        <Slot render={slots?.selectedImage}>
          <div className={styles.selectedImageContainer}>
            {imageSelection.images.length > 0 ? (
              isDesktop && config.features.fullSizeImageGallery.enabled ? (
                <FullsizeImageGallery
                  images={formattedImages}
                  imagesToShow={imagesToShow}
                />
              ) : (
                <ImageGallery
                  items={formattedImages}
                  showPlayButton={false}
                  showThumbnails={imageSelection.images.length > 0}
                  showNav={showCarouselArrows}
                  showFullscreenButton={false}
                />
              )
            ) : (
              <img
                style={{ width: '100%' }}
                alt={formattedImages[0].alt}
                src={formattedImages[0].original}
                title={formattedImages[0].title}
              />
            )}
          </div>
        </Slot>

        <Slot render={slots?.imageHint}>
          <small>{t('productDetail.imageMayDifferHint')}</small>
        </Slot>
      </LYSContainer>
    )
  }
)
export default ProductImage
